import { useEffect } from "react";
import { Container } from "reactstrap";
import { ECommerce, Product } from "../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { fetchProductJsonData } from "../../../../reduxToolkit/reducers/eCommerce/productSlice";
import Summary from "./summary";
import GridView from "./gridView";
import Sidebar from "./sideBar";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component displays the product details page with a sidebar and grid view.
const ProductContainer = () => {
  const sideBarOn = useAppSelector((state) => state.filterData.sideBarOn);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductJsonData());
  }, [dispatch]);

  return (
    <>
      <Breadcrumbs mainTitle={Product} parent={ECommerce} />
      <Container fluid className={`product-wrapper ${sideBarOn ? "sidebaron" : ""}`}>
        <div className="product-grid">
          <div className="feature-products">
            <Summary />
            <Sidebar />
          </div>
          <GridView />
        </div>
      </Container>
    </>
  );
};

export default ProductContainer;